import styles from "./UserChatMessage.module.css";
import userImage from "../../assets/user.svg";
import { prettifyMessageForDisplay } from "../../utils/siteNames";

interface Props {
    message: string;
}

export const UserChatMessage = ({ message }: Props) => {
    return (
        <div className="flex flex-row-reverse items-start text-right gap-2.5 mb-4">
            <img className="w-8 h-8 rounded-full  border bg-[#009835]" src={userImage} alt="user image"/>
            <div
                className="flex flex-col w-full max-w-lg leading-1.5 p-4 border-gray-200 shadow-sm rounded-xl rounded-tr-sm bg-white">

                <div className="text-sm font-semibold text-gray-900">
                    Sie
                </div>
                <p className="text-sm font-normal py-1 text-gray-900 ">{prettifyMessageForDisplay(message)}</p>
            </div>
        </div>
    );
};
